import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, useIntl } from "react-intl"
import { Typography } from "@carrotfertility/carotene-core"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { SelectStep } from "#/components/carrot-card-cost-share/steps/variants/SelectStep"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { WhoWillReceiveCareValues } from "#/components/carrot-card-cost-share/steps/shared/stepOptionValues"

const recipientOptions = [
  { label: defineMessage({ defaultMessage: "Me" }), value: WhoWillReceiveCareValues.ME },
  {
    label: defineMessage({ defaultMessage: "My legal spouse or tax-dependent partner" }),
    value: WhoWillReceiveCareValues.LEGAL_PARTNER
  },
  {
    label: defineMessage({ defaultMessage: "My non-married partner" }),
    value: WhoWillReceiveCareValues.NON_MARRIED_PARTNER
  },
  {
    label: defineMessage({ defaultMessage: "Birth parent for adoption" }),
    value: WhoWillReceiveCareValues.BIRTH_PARENT
  }
]

export function WhoWillReceiveCareAdoptionStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { whoReceivedCare },
    serverState: { checkPartnerEligibility }
  } = useContext(CarrotCardCostSharePreAuthContext)
  const formattedOptions = useConvertTranslatedLabel(recipientOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({ type: "UPDATE_FIELD", field: "whoReceivedCare", value: formValues.whoReceivedCare })

    const partnerEligibility = checkPartnerEligibility(formValues.whoReceivedCare)
    send(partnerEligibility)
  }

  return (
    <SelectStep
      title={intl.formatMessage({ defaultMessage: "Who will receive the care or service?" })}
      description={
        <Typography sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.xl })}>
          {intl.formatMessage({
            defaultMessage:
              "If you have eligible expenses for more than one person, these need to be authorized as separate transactions."
          })}
        </Typography>
      }
      selectName="whoReceivedCare"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={whoReceivedCare}
    />
  )
}
